export const SCHEDULE_TYPE = {
  VEHICLE_INSPECTION: 1, // Đăng kiểm xe định kỳ
  NEW_VEHICLE_INSPECTION: 2, // đăng kiểm xe mới
  CHANGE_REGISTATION: 4, // Đổi mục đích sử dụng, đổi chủ, đổi thông tin hồ sơ
  PAY_ROAD_FEE: 5, // Thanh toán phí đường bộ
  PAY_INSURRANCE_FEE: 6, // Thanh toán phí bảo hiểm
  REGISTER_EPASS_TAG: 2, // Đăng ký dán thẻ EPASS
  REGISTER_NEW_VEHICLE: 3, // nộp hồ sơ xe mới
  CONSULTANT_MAINTENANCE: 7, // Đặt lịch tư vấn bảo dưỡng
  CONSULTANT_INSURANCE: 8, // Đặt lịch tư bảo hiểm vật chất xe ô tô
  CONSULTANT_RENOVATION: 9, // Đặt lịch tư vấn cải tạo xe
  LOST_REGISTRATION_PAPER: 10, // Mất giấy đăng kiểm
  REISSUE_INSPECTION_STICKER: 11, // Cấp lại tem đăng kiểm
  VEHICLE_INSPECTION_CONSULTATION: 12, // Tư vấn đăng kiểm xe
  TRAFFIC_FINE_CONSULTATION: 13, // Tư vấn xử lý phạt nguội
  CONSULTANT_TNDS_INSURANCE: 14, // Tư vấn bảo hiểm vật chất xe ô tô
  AUTO_NOTIFY_VIOLATION: 15, // Tra cứu cảnh báo đăng kiểm
  SUPPORT_FINE_RESOLUTION: 16, // Hỗ trợ xử lý phạt nguội
  GPS_RENEWAL: 17, // Gia hạn định vị
  BUSINESS_VEHICLE_BADGE_RENEWAL: 18, // Gia hạn phù hiệu xe kinh doanh
  TRAINING_CERTIFICATE_RENEWAL: 19, // Gia hạn giấy tập huấn
  DASHCAM_RENEWAL: 20, // Gia hạn camera hành trình
  REGISTER_VETC_TAG: 21, // Đăng ký dán thẻ VETC
  TNDS_INSURANCE_RENEWAL: 22, // Gia hạn BH TNDS
  OFF_HOUR_NEW_VEHICLE_REGISTER: 23, // Nộp hồ sơ xe mới (Ngoài giờ HC)
  OFF_HOUR_VEHICLE_INSPECTION: 24, // Đăng kiểm xe (Ngoài giờ HC)
  CONSULTANT_INSURANCE_COMPENSATION: 25, // Tư vấn bồi thường bảo hiểm
  CONSULTANT_DRIVER_HEALTH: 26, // Tư vấn sức khỏe lái xe
  E_TICKET_SALE: 27 // Bán vé điện tử
}

export const SCHEDULE_TYPE_MINIAPP = {
  VEHICLE_INSPECTION: 1, // Đăng kiểm xe định kỳ
  REGISTER_NEW_VEHICLE: 3, // nộp hồ sơ xe mới
  CONSULTANT_INSURANCE_COMPENSATION: 25, // Tư vấn bồi thường bảo hiểm
  CHANGE_REGISTATION: 4, // Đổi mục đích sử dụng, đổi chủ, đổi thông tin hồ sơ
  VEHICLE_INSPECTION_CONSULTATION: 12, // Tư vấn đăng kiểm xe định kỳ
  TRAFFIC_FINE_CONSULTATION: 13, // Tư vấn xử lý phạt nguội
  CONSULTANT_MAINTENANCE: 7, // Đặt lịch tư vấn bảo dưỡng
  CONSULTANT_TNDS_INSURANCE: 14, // Tư vấn bảo hiểm TNDS xe ô tô
  CONSULTANT_INSURANCE: 8, // Đặt lịch tư bảo hiểm vật chất xe ô tô
  CONSULTANT_RENOVATION: 9, // Đặt lịch tư vấn cải tạo xe
  LOST_REGISTRATION_PAPER: 10, // Mất giấy đăng kiểm
  REISSUE_INSPECTION_STICKER: 11, // Cấp lại tem đăng kiểm
  E_TICKET_SALE: 27 // Bán vé điện tử
}

export const PARENT_SERVICE_TYPES = {
  INSPECTION_AND_DOCUMENT: 1,
  VIOLATION_AND_FINE: 2,
  INSURANCE: 3,
  MAINTENANCE_AND_RENOVATION: 4,
  E_TOLL_AND_TICKET: 5,
  E_TICKET: 6,
  RENEWAL: 7,
  OTHER: 8
}

export const SCHEDULE_TYPE_PARENT_SERVICE_TYPE = {
  [SCHEDULE_TYPE.VEHICLE_INSPECTION]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.REGISTER_NEW_VEHICLE]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.CHANGE_REGISTATION]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.LOST_REGISTRATION_PAPER]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.REISSUE_INSPECTION_STICKER]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.OFF_HOUR_NEW_VEHICLE_REGISTER]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.OFF_HOUR_VEHICLE_INSPECTION]: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  [SCHEDULE_TYPE.AUTO_NOTIFY_VIOLATION]: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  [SCHEDULE_TYPE.SUPPORT_FINE_RESOLUTION]: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  [SCHEDULE_TYPE.PAY_INSURRANCE_FEE]: PARENT_SERVICE_TYPES.INSURANCE,
  [SCHEDULE_TYPE.TNDS_INSURANCE_RENEWAL]: PARENT_SERVICE_TYPES.INSURANCE,
  [SCHEDULE_TYPE.PAY_ROAD_FEE]: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  [SCHEDULE_TYPE.REGISTER_EPASS_TAG]: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  [SCHEDULE_TYPE.REGISTER_VETC_TAG]: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  [SCHEDULE_TYPE.CONSULTANT_MAINTENANCE]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.CONSULTANT_INSURANCE]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.CONSULTANT_RENOVATION]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.VEHICLE_INSPECTION_CONSULTATION]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.TRAFFIC_FINE_CONSULTATION]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.CONSULTANT_TNDS_INSURANCE]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.CONSULTANT_INSURANCE_COMPENSATION]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.CONSULTANT_DRIVER_HEALTH]: PARENT_SERVICE_TYPES.OTHER,
  [SCHEDULE_TYPE.GPS_RENEWAL]: PARENT_SERVICE_TYPES.RENEWAL,
  [SCHEDULE_TYPE.BUSINESS_VEHICLE_BADGE_RENEWAL]: PARENT_SERVICE_TYPES.RENEWAL,
  [SCHEDULE_TYPE.TRAINING_CERTIFICATE_RENEWAL]: PARENT_SERVICE_TYPES.RENEWAL,
  [SCHEDULE_TYPE.DASHCAM_RENEWAL]: PARENT_SERVICE_TYPES.RENEWAL,
  [SCHEDULE_TYPE.E_TICKET_SALE]: PARENT_SERVICE_TYPES.E_TICKET
}

export const SERVICE_TYPE_PARENT_SERVICE_TYPE = {
  1: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  2: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  3: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  4: PARENT_SERVICE_TYPES.INSURANCE,
  5: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  6: PARENT_SERVICE_TYPES.INSURANCE,
  7: PARENT_SERVICE_TYPES.MAINTENANCE_AND_RENOVATION,
  8: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  9: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  10: PARENT_SERVICE_TYPES.MAINTENANCE_AND_RENOVATION,
  11: PARENT_SERVICE_TYPES.OTHER,
  12: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  13: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  14: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  15: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  16: PARENT_SERVICE_TYPES.E_TOLL_AND_TICKET,
  18: PARENT_SERVICE_TYPES.OTHER,
  19: PARENT_SERVICE_TYPES.OTHER,
  20: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  21: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  22: PARENT_SERVICE_TYPES.OTHER,
  23: PARENT_SERVICE_TYPES.OTHER,
  24: PARENT_SERVICE_TYPES.OTHER,
  25: PARENT_SERVICE_TYPES.OTHER,
  26: PARENT_SERVICE_TYPES.VIOLATION_AND_FINE,
  27: PARENT_SERVICE_TYPES.RENEWAL,
  28: PARENT_SERVICE_TYPES.RENEWAL,
  29: PARENT_SERVICE_TYPES.RENEWAL,
  30: PARENT_SERVICE_TYPES.RENEWAL,
  31: PARENT_SERVICE_TYPES.INSURANCE,
  32: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  33: PARENT_SERVICE_TYPES.INSPECTION_AND_DOCUMENT,
  34: PARENT_SERVICE_TYPES.RENEWAL,
  35: PARENT_SERVICE_TYPES.OTHER,
  36: PARENT_SERVICE_TYPES.E_TICKET,
  37: PARENT_SERVICE_TYPES.E_TICKET,
  38: PARENT_SERVICE_TYPES.E_TICKET,
  39: PARENT_SERVICE_TYPES.MAINTENANCE_AND_RENOVATION,
  40: PARENT_SERVICE_TYPES.MAINTENANCE_AND_RENOVATION,
  10000: PARENT_SERVICE_TYPES.OTHER
}

export const CONSULTANT_TYPE = {
  CONSULTANT_INSURANCE_COMPENSATION: 25, // Tư vấn bồi thường bảo hiểm
  VEHICLE_INSPECTION_CONSULTATION: 12, // Tư vấn đăng kiểm xe định kỳ
  TRAFFIC_FINE_CONSULTATION: 13, // Tư vấn xử lý phạt nguội
  CONSULTANT_MAINTENANCE: 7, // Đặt lịch tư vấn bảo dưỡng
  CONSULTANT_TNDS_INSURANCE: 14, // Tư vấn bảo hiểm TNDS xe ô tô
  CONSULTANT_INSURANCE: 8, // Đặt lịch tư bảo hiểm vật chất xe ô tô
  CONSULTANT_RENOVATION: 9, // Đặt lịch tư vấn cải tạo xe
  CONSULTANT_DRIVER_HEALTH: 26 // Tư vấn sức khỏe lái xe
}

export const SCHEDULE_TITLE = {
  [SCHEDULE_TYPE.VEHICLE_INSPECTION]: {
    title: 'Đăng kiểm xe định kỳ',
    subTitle: 'Dành cho khách hàng đặt lịch để đăng kiểm các xe đã đăng kiểm trước đây'
  },
  [SCHEDULE_TYPE.NEW_VEHICLE_INSPECTION]: {
    title: 'Đăng kiểm xe mới',
    subTitle: 'Dành cho khách hàng đăng kiểm lần đầu - không mang phương tiện đến trạm đăng kiểm'
  },
  [SCHEDULE_TYPE.CHANGE_REGISTATION]: {
    title: 'Thay đổi thông tin xe',
    subTitle: 'Dành cho khách hàng muốn đổi mục đích sử dụng phương tiện, hoặc đổi thông tin chủ sở hữu xe, biển số xe'
  },
  [SCHEDULE_TYPE.PAY_ROAD_FEE]: {
    title: 'Thanh toán phí đường bộ',
    subTitle: 'Dành cho khách hàng muốn thanh toán phí đường bộ'
  },
  [SCHEDULE_TYPE.PAY_INSURRANCE_FEE]: {
    title: 'Thanh toán phí bảo hiểm',
    subTitle: 'Dành cho khách hàng muốn thanh toán phí bảo hiểm'
  },
  [SCHEDULE_TYPE.REGISTER_EPASS_TAG]: {
    title: 'Đăng ký dán thẻ EPASS',
    subTitle: 'Dành cho khách hàng muốn dán thẻ thu phí không dừng EPASS cho xe'
  },
  [SCHEDULE_TYPE.REGISTER_NEW_VEHICLE]: {
    title: 'Nộp hồ sơ xe mới',
    subTitle: 'Dành cho khách hàng muốn nộp hồ sơ xe mới trước khi đăng kiểm'
  },
  [SCHEDULE_TYPE.CONSULTANT_MAINTENANCE]: {
    title: 'Tư vấn bảo dưỡng',
    subTitle: 'Dành cho khách hàng muốn được tư vấn bảo dưỡng xe định kỳ hoặc theo nhu cầu'
  },
  [SCHEDULE_TYPE.CONSULTANT_INSURANCE]: {
    title: 'Tư vấn bảo hiểm vật chất xe ô tô',
    subTitle: 'Dành cho khách hàng cần tư vấn về các loại bảo hiểm xe ô tô'
  },
  [SCHEDULE_TYPE.CONSULTANT_RENOVATION]: {
    title: 'Tư vấn cải tạo xe',
    subTitle: 'Dành cho khách hàng muốn cải tạo kết cấu phương tiện'
  },
  [SCHEDULE_TYPE.LOST_REGISTRATION_PAPER]: {
    title: 'Mất giấy đăng kiểm',
    subTitle: 'Dành cho khách hàng bị mất giấy đăng kiểm và cần hỗ trợ cấp lại'
  },
  [SCHEDULE_TYPE.REISSUE_INSPECTION_STICKER]: {
    title: 'Cấp lại tem đăng kiểm',
    subTitle: 'Dành cho khách hàng cần xin cấp lại tem đăng kiểm đã mất hoặc hư hỏng'
  },
  [SCHEDULE_TYPE.VEHICLE_INSPECTION_CONSULTATION]: {
    title: 'Tư vấn đăng kiểm xe định kỳ',
    subTitle: 'Dành cho khách hàng muốn được tư vấn trước khi đưa xe đi đăng kiểm'
  },
  [SCHEDULE_TYPE.TRAFFIC_FINE_CONSULTATION]: {
    title: 'Tư vấn phạt nguội',
    subTitle: 'Dành cho khách hàng cần tư vấn xử lý các lỗi vi phạm phạt nguội'
  },
  [SCHEDULE_TYPE.CONSULTANT_TNDS_INSURANCE]: {
    title: 'Tư vấn bảo hiểm TNDS xe ô tô',
    subTitle: 'Dành cho khách hàng cần tư vấn bảo hiểm TNDS xe ô tô'
  },
  [SCHEDULE_TYPE.AUTO_NOTIFY_VIOLATION]: {
    title: 'Tra cứu cảnh báo đăng kiểm',
    subTitle: 'Dành cho khách hàng muốn biết xe có vi phạm hoặc bị từ chối đăng kiểm không'
  },
  [SCHEDULE_TYPE.SUPPORT_FINE_RESOLUTION]: {
    title: 'Hỗ trợ xử lý phạt nguội',
    subTitle: 'Dành cho khách hàng cần hỗ trợ giải quyết các lỗi vi phạm giao thông chưa xử lý'
  },
  [SCHEDULE_TYPE.GPS_RENEWAL]: {
    title: 'Gia hạn định vị',
    subTitle: 'Dành cho khách hàng muốn gia hạn dịch vụ định vị GPS trên xe'
  },
  [SCHEDULE_TYPE.BUSINESS_VEHICLE_BADGE_RENEWAL]: {
    title: 'Gia hạn phù hiệu xe KD',
    subTitle: 'Dành cho khách hàng cần gia hạn phù hiệu xe kinh doanh vận tải'
  },
  [SCHEDULE_TYPE.TRAINING_CERTIFICATE_RENEWAL]: {
    title: 'Gia hạn giấy tập huấn',
    subTitle: 'Dành cho tài xế cần gia hạn giấy chứng nhận tập huấn'
  },
  [SCHEDULE_TYPE.DASHCAM_RENEWAL]: {
    title: 'Gia hạn camera hành trình',
    subTitle: 'Dành cho khách hàng muốn gia hạn lưu trữ hoặc dịch vụ camera hành trình'
  },
  [SCHEDULE_TYPE.REGISTER_VETC_TAG]: {
    title: 'Đăng ký dán thẻ VETC',
    subTitle: 'Dành cho khách hàng muốn dán thẻ thu phí không dừng VETC cho xe'
  },
  [SCHEDULE_TYPE.TNDS_INSURANCE_RENEWAL]: {
    title: 'Gia hạn BH TNDS',
    subTitle: 'Dành cho khách hàng muốn gia hạn bảo hiểm trách nhiệm dân sự bắt buộc'
  },
  [SCHEDULE_TYPE.OFF_HOUR_NEW_VEHICLE_REGISTER]: {
    title: 'Nộp hồ sơ xe mới (ngoài giờ HC)',
    subTitle: 'Dành cho khách hàng cần hỗ trợ nộp hồ sơ xe mới ngoài giờ hành chính'
  },
  [SCHEDULE_TYPE.OFF_HOUR_VEHICLE_INSPECTION]: {
    title: 'Đăng kiểm xe (ngoài giờ HC)',
    subTitle: 'Dành cho khách hàng cần đăng kiểm xe ngoài giờ hành chính'
  },
  [SCHEDULE_TYPE.CONSULTANT_INSURANCE_COMPENSATION]: {
    title: 'Tư vấn bồi thường bảo hiểm',
    subTitle: 'Dành cho khách hàng cần hỗ trợ làm hồ sơ bồi thường bảo hiểm'
  },
  [SCHEDULE_TYPE.CONSULTANT_DRIVER_HEALTH]: {
    title: 'Tư vấn sức khỏe lái xe',
    subTitle: 'Dành cho tài xế cần tư vấn, khám sức khỏe để lái xe theo quy định'
  },
  [SCHEDULE_TYPE.E_TICKET_SALE]: {
    title: 'Bán vé điện tử',
    subTitle: 'Dành cho khách hàng muốn mua vé điện tử cho các dịch vụ liên quan đến giao thông'
  }
}

export const SCHEDULE_DATA = [
  {
    id: SCHEDULE_TYPE.VEHICLE_INSPECTION,
    ...SCHEDULE_TITLE[SCHEDULE_TYPE.VEHICLE_INSPECTION],
    icon: require('../assets/icons/dk_xe_cu.png')
  },
  {
    id: SCHEDULE_TYPE.CHANGE_REGISTATION,
    ...SCHEDULE_TITLE[SCHEDULE_TYPE.CHANGE_REGISTATION],
    icon: require('../assets/icons/Isolation_Mode.png')
  }
]

export const optionServiceType = [
  { value: 1, label: 'Tra cứu phạt nguội' },
  { value: 2, label: 'Dán thẻ VETC' },
  { value: 3, label: 'Đóng phí phạt nguội' },
  { value: 4, label: 'Gia hạn bảo hiểm TNDS' },
  { value: 5, label: 'Đóng phí VETC' },
  { value: 6, label: 'Gia hạn BH thân vỏ' },
  { value: 7, label: 'Bảo dưỡng, sửa chữa xe cơ giới' },
  { value: 8, label: 'Đăng kiểm xe cơ giới' },
  { value: 9, label: 'Nạp tiền ePass' },
  { value: 10, label: 'Cứu hộ xe bị hư hỏng' },
  { value: 11, label: 'Tư vấn hoán cải' },
  { value: 12, label: 'Tự động thông báo phạt nguội' },
  { value: 13, label: 'Đăng kiểm xe cũ' },
  { value: 14, label: 'Nộp hồ sơ xe mới' },
  { value: 15, label: 'Đổi mục đích sử dụng, đổi chủ, đổi thông tin hồ sơ' },
  { value: 16, label: 'Thanh toán phí đường bộ' },
  { value: 18, label: 'Đặt lịch tư vấn bảo dưỡng' },
  { value: 19, label: 'Đặt lịch tư vấn bảo hiểm' },
  { value: 20, label: 'Mất giấy đăng kiểm' },
  { value: 21, label: 'Cấp lại tem đăng kiểm' },
  { value: 22, label: 'Tư vấn đăng kiểm xe' },
  { value: 23, label: 'Tư vấn xử lý phạt nguội' },
  { value: 24, label: 'Tư vấn bảo hiểm TNDS xe ô tô' },
  { value: 25, label: 'Tra cứu cảnh báo đăng kiểm' },
  { value: 26, label: 'Hỗ trợ xử lý phạt nguội' },
  { value: 27, label: 'Gia hạn định vị' },
  { value: 28, label: 'Gia hạn phù hiệu xe kinh doanh' },
  { value: 29, label: 'Gia hạn giấy tập huấn' },
  { value: 30, label: 'Gia hạn camera hành trình' },
  { value: 31, label: 'Gia hạn BH TNDS' },
  { value: 32, label: 'Nộp hồ sơ xe mới (Ngoài giờ HC)' },
  { value: 33, label: 'Đăng kiểm xe (Ngoài giờ HC)' },
  { value: 34, label: 'Khám sức khỏe lái xe' },
  { value: 35, label: 'Tư vấn bồi thường bảo hiểm' },
  { value: 36, label: 'Vé vào cổng' },
  { value: 37, label: 'Vé cầu' },
  { value: 38, label: 'Vé lượt' },
  { value: 39, label: 'Chăm sóc xe' },
  { value: 40, label: 'Rửa xe' }
]

export const MAIN_BUTTON_TITLES = {
  'Đăng kiểm xe': {
    subTitle: 'Đặt lịch đăng kiểm, thay đổi thông tin, nộp hồ sơ'
  },
  'Bảo hiểm': {
    subTitle: 'Mua bảo hiểm TNDS, tư vấn bảo hiểm'
  },
  'Kiểm tra phạt nguội': {
    subTitle: 'Tra cứu và xử lý phạt nguội'
  },
  'Tư vấn hỗ trợ': {
    subTitle: 'Liên hệ hỗ trợ khách hàng'
  }
}
